import React, { useCallback, useState } from "react";

import {
  WorkflowCommands,
  WorkflowCommandsContext,
} from "./WorkflowCommandsContext";

export const WorkflowCommandsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [commands, setCommands] = useState<WorkflowCommands>({});
  const unregisterCommands = useCallback(() => setCommands({}), []);

  return (
    <WorkflowCommandsContext.Provider
      value={{
        commands,
        registerCommands: setCommands,
        unregisterCommands,
      }}
    >
      {children}
    </WorkflowCommandsContext.Provider>
  );
};
